import { render, staticRenderFns } from "./TypeCertificate.vue?vue&type=template&id=259d4007&scoped=true"
import script from "./TypeCertificate.vue?vue&type=script&lang=js"
export * from "./TypeCertificate.vue?vue&type=script&lang=js"
import style0 from "./TypeCertificate.scss?vue&type=style&index=0&id=259d4007&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259d4007",
  null
  
)

export default component.exports